import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { TextRecordComponent } from '../components/text-record/text-record.component';
import { IonSelectCustomEvent } from '@ionic/core';
import { SelectChangeEventDetail } from '@ionic/angular';
import { IonPopover } from '@ionic/angular';
import { TextRecordHistoryComponent } from '../components/text-record-history/text-record-history.component';

@Component({
  selector: 'app-text-list',
  templateUrl: './text-list.page.html',
  styleUrls: ['./text-list.page.scss'],
})
export class TextListPage implements OnInit {
  textListData: any[] = []; // Full data from API
  searchQuery: string = ''; //variable for search
  

  // variables for footer
  totalPages: number = 5;
  currentPage: number = 1;
  pageSize: number = 20;
  pageSizeOptions = [20, 50, 100];

  //varialbes for Selection
  selectedOption !: string | null;
  options = [
      { label: 'Dutch', value: 'nl' },
      { label: 'English', value: 'english' },
  ];
  selectedOptionCategory : string | null = 'all';
  options_category = [
    { label: 'All', value: 'all' },
    { label: 'PrioritizeText', value: 'prioritize_text' },
    { label: 'MozillaText', value: 'mozilla_text' },
    { label: 'Text', value: 'text' },
    { label: 'SurveyForms', value: 'surveyforms' },
    { label: 'Character', value: 'character' },
    { label: 'Number', value: 'number' },
    { label: 'Outbound', value: 'outbound' },
  ]

  selectedOptionRecordedText: string | null = 'all';
  selectedOptionTotalRecordedText: string | null = 'all';
  options_recorded_text = [
    { label: 'All', value: 'all', filter_position:'9' },
    { label: 'Never recorded', value: '0', filter_position:'1'},
    { label: '1 times', value: '1', filter_position:'2' },
    { label: '2 times', value: '2', filter_position:'3' },
    { label: '3 times', value: '3', filter_position:'4' },
    { label: '4 times', value: '4', filter_position:'5' },
    { label: '5 times', value: '5', filter_position:'6' },
    { label: '6 times', value: '6', filter_position:'7' },
    { label: '7 times', value: '7', filter_position:'8' },
  ]
  filteredTotalRecordedOptions = [...this.options_recorded_text];

  // varialbes for user details
  userName !: string | null;
  userLanguage !: string | null;
  userAccent !: string | null;
  userAge !: string | null;
  userGender !: string | null;
  userId !: string | null;

  constructor(
    private modalCtrl: ModalController,
    private apiService:ApiService,
    private router:Router,
    private globalService:GlobalService,
    private http: HttpClient,
    private alertController: AlertController,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // this.selectedOption = localStorage.getItem('langCategory') || 'nl';
    // this.selectedOptionCategory = localStorage.getItem('textCategory') || 'all';
    // this.selectedOptionRecordedText = localStorage.getItem('numberOfRecordedText') || 'all';
    // this.selectedOptionTotalRecordedText = localStorage.getItem('numberOfTotalRecordedText') || 'all';
    // this.fetchTextList();
  }
  ionViewWillEnter() {
    console.log("Page Entered - Fetching Data");
    this.selectedOption = localStorage.getItem('langCategory') || 'nl';
    this.selectedOptionCategory = localStorage.getItem('textCategory') || 'all';
    this.selectedOptionTotalRecordedText = localStorage.getItem('numberOfTotalRecordedText') || 'all';
    this.selectedOptionRecordedText = localStorage.getItem('numberOfRecordedText') || 'all';
    this.fetchTextList();

    //user details fetched from localstorage
    this.userName = localStorage.getItem('userName');
    this.userLanguage = localStorage.getItem('language');
    this.userAccent = localStorage.getItem('accent');
    this.userAge = localStorage.getItem('age');
    this.userGender = localStorage.getItem('gender');
    this.userId = localStorage.getItem('userId');

   


  }

  async ionViewWillLeave() {
    console.log("Ion View Will Leave Triggered");

    // Perform any cleanup tasks
    // Reset variables for different variables
    this.textListData = [];
    this.currentPage = 1;
    this.searchQuery = '';

    // Reset variables for filter
    localStorage.setItem('numberOfRecordedText','all'); // update the localStorage value for Recorded text count
    localStorage.setItem('numberOfTotalRecordedText','all'); // update the localStorage value for Recorded text count
    localStorage.setItem('textCategory','all'); // update the localStorage value for category
    localStorage.setItem('langCategory','nl'); // update the localStorage value for language

    this.filteredTotalRecordedOptions = [...this.options_recorded_text];
  }
  
  async ionViewDidLeave() {
    console.log("Ion View Did Leave Triggered");
    // Perform actions after leaving the page
  }

  clearSearch(){
    this.searchQuery =  ''
    this.currentPage = 1;
    this.fetchTextList();
  }

  onSearchInputChange(){
    // const query = this.ttsForm.get('searchQuery')?.value;
    if (this.searchQuery === '') {
      // Make API call when input is cleared
      this.clearSearch();
    }
  }

  onSearch(){
    this.currentPage = 1;
    console.log("Search function is called",this.searchQuery);
    this.fetchTextList();
  }



  // fetchTextList() {
  //   this.globalService.logoutLoading(); // Show loading indicator

  //   const lang = this.selectedOption || localStorage.getItem('language') ||  'nl';
  //   const cate = this.selectedOptionCategory || localStorage.getItem('textCategory') || 'all';
  //   const recorded_text = this.selectedOptionRecordedText || localStorage.getItem('numberOfRecordedText') || 'all'; //it will used to filter the recorded text
  //   const total_recorded_text = this.selectedOptionTotalRecordedText || localStorage.getItem('numberOfTotalRecordedText') || 'all'; //it will used to filter the recorded text
  //   const current_page = this.currentPage || localStorage.getItem('currentPageForHome') || '1';
  //   const page_size = this.pageSize ||  localStorage.getItem('currentPageSizeForHome') || '20';
  //   try {
  //     this.apiService.retriveTextList(lang, cate, recorded_text,total_recorded_text,current_page,page_size).subscribe(
  //       (response) => {
  //         if (response?.data) {
  //           this.textListData = response.data || [];
  //           this.globalService.dismissLoading(); // Hide loading indicator
  
  //           // calculate the total page
  //           this.totalPages = Math.ceil(response.totalCount / this.pageSize) || 1;
  //         }else{
  //           this.totalPages = 1;
  //         }


          
  //       },
  //       (err) => {
  //         // Handle errors within the subscribe error callback
  //         console.error(err);
  //         this.textListData = [];
  //         this.globalService.dismissLoading(); // Hide loading on error
  //       }
  //     );
  //   } catch (error) {
  //     // Handle synchronous errors that might occur before the subscribe call
  //     console.error("An error occurred before the API call:", error);
  //     this.textListData = []; // Ensure textListData is reset
  //     this.globalService.dismissLoading(); // Ensure loading is dismissed on any error
  //   }
  // }

  fetchTextList() {
    this.globalService.logoutLoading(); // Show loading indicator
  
    try {
      const lang = this.selectedOption || localStorage.getItem('language') || 'nl';
      const cate = this.selectedOptionCategory || localStorage.getItem('textCategory') || 'all';
      const recorded_text = this.selectedOptionRecordedText || localStorage.getItem('numberOfRecordedText') || 'all';
      const total_recorded_text = this.selectedOptionTotalRecordedText || localStorage.getItem('numberOfTotalRecordedText') || 'all';
      const current_page = this.currentPage || localStorage.getItem('currentPageForHome') || '1';
      const page_size = this.pageSize || localStorage.getItem('currentPageSizeForHome') || '20';
      const searchQuery = this.searchQuery;
  
      this.apiService.retriveTextList(lang, cate, recorded_text,total_recorded_text, current_page, page_size,searchQuery).subscribe({
        next: (response) => {
          try {
            if (response?.data) {
              this.textListData = response.data;
              console.log("Tttttttext List Data is:", this.textListData);
              this.totalPages = Math.ceil(response.totalCount / Number(page_size)) || 1;
            } else {
              console.error("Invalid response format: Missing 'data' key", response);
              this.textListData = [];
              this.totalPages = 1;
            }
          } catch (processingError) {
            console.error("Error while processing response:", processingError);
            this.textListData = [];
            this.totalPages = 1;
          } finally {
            this.globalService.dismissLoading(); // Hide loading indicator
          }
        },
        error: (err) => {
          console.error("API call failed:", err);
          this.textListData = [];
          this.totalPages = 1;
          this.globalService.dismissLoading(); // Hide loading on error
        }
      });
    } catch (setupError) {
      console.error("An error occurred before the API call:", setupError);
      this.textListData = [];
      this.totalPages = 1;
      this.globalService.dismissLoading(); // Hide loading on setup error
    }
  }
  

  updateText(item:any){
    this.showAlert(item.TextId,item.Text)
  }

  deleteText(item:any){
    console.log("text has been deleted",item);
    this.showDeleteAlert(item.TextId,item.Text);

  }

  async showAlert(textId: string, oldText: string) {
    const alert = await this.alertController.create({
      header: 'Update Text',
      cssClass: 'custom-alert',
      inputs: [
        {
          name: 'newText',
          type: 'text',
          value: oldText, // Set existing text here
          placeholder: 'Enter new text here !!!'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Update',
          handler: (data) => {
            console.log('User Input:', data);
            const requestBody = {
              UpdatedText: data.newText  // Correct field name
            };
            if (data.newText) {
              this.apiService.updateText(textId, requestBody).subscribe(
                async (response) => {
                  console.log("Data has been updated successfully.");
                  this.fetchTextList(); //teporarily added when updated call api to refresh
                },
                (err) => {
                  console.error("Error during API call:", err);
                }
              );
            } else {
              console.warn("No audio data to save");
            }
          }
        }
      ]
    });
  
    await alert.present();
  }

  async showDeleteAlert(textId: string,text:string) {
    const alert = await this.alertController.create({
      header: 'Confirm Deletion',
      message: `Are you sure you want to delete "${text}"?`,
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Delete',
          handler: async () => {
            this.apiService.deleteText(textId).subscribe(
              async (response) => {
                console.log("Text has been deleted successfully.");
                // this.fetchTextList(); //teporarily added when updated call api to refresh
                this.updateRowValueOnDelete(textId);
              },
              (err) => {
                console.error("Error during delete API call:", err);
              }
            );
          }
        }
      ]
    });
  
    await alert.present();
  }


  updateRowValueOnDelete(textId: string) {
    this.textListData = this.textListData.filter(row => row.TextId !== textId);
  }
  
  


  async onOptionChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
        this.currentPage = 1;
        this.globalService.logoutLoading();
        const updateLang = $event.detail.value;
        this.selectedOption = updateLang;
        localStorage.setItem('langCategory', updateLang);
        await this.fetchTextList();
        
    }
  async onOptionCategoryChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
        this.globalService.logoutLoading();
        const updateCategory = $event.detail.value;
        this.selectedOptionCategory = updateCategory;
        localStorage.setItem('textCategory', updateCategory);
        await this.fetchTextList();
      
  }
  async onOptionRecordedTextChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
    this.globalService.logoutLoading();
    const selectedValue = $event.detail.value;
    const selectedOption = this.options_recorded_text.find(opt => opt.value === selectedValue);

    if (!selectedOption) {
      this.filteredTotalRecordedOptions = [...this.options_recorded_text];
      return;
    }

    const selectedFilterPosition = parseInt(selectedOption.filter_position, 10);

    if (selectedFilterPosition === 9) {
      this.filteredTotalRecordedOptions = [...this.options_recorded_text];
    } else {
      this.filteredTotalRecordedOptions = this.options_recorded_text.filter(option => {
        const optionFilterPosition = parseInt(option.filter_position, 10);
        return optionFilterPosition >= selectedFilterPosition;
      });
    }

    if (this.selectedOptionTotalRecordedText) {
      const stillValid = this.filteredTotalRecordedOptions.find(opt => opt.value === this.selectedOptionTotalRecordedText);
      if (!stillValid) {
        this.selectedOptionTotalRecordedText = null;
      }
    }

    //update the value of 'selectedOptionTotalRecordedText'
    var storedValue = localStorage.getItem('numberOfTotalRecordedText') || 'all';

    var exists = this.filteredTotalRecordedOptions.some(function(option: { value: string | null; }) {
      return option.value === storedValue;
    });

    if (exists) {
      this.selectedOptionTotalRecordedText = storedValue;
    } else {
      this.selectedOptionTotalRecordedText = 'all';
      localStorage.setItem('numberOfTotalRecordedText','all'); // update the localStorage value for Recorded text count
    }


    // const updateRecordedTextCategory = $event.detail.value;
    const updateRecordedTextCategory = selectedValue;
    this.selectedOptionRecordedText = updateRecordedTextCategory;
    localStorage.setItem('numberOfRecordedText', updateRecordedTextCategory);

    await this.fetchTextList();
  
  }

  async onOptionTotalRecordedTextChange($event: IonSelectCustomEvent<SelectChangeEventDetail<any>>) {
    this.globalService.logoutLoading();
    const updateTotalRecordedTextCategory = $event.detail.value;
    this.selectedOptionTotalRecordedText = updateTotalRecordedTextCategory;
    localStorage.setItem('numberOfTotalRecordedText', updateTotalRecordedTextCategory);
    await this.fetchTextList();
  
  }


  async openTextRecorFormModal(item: any) {
    const modal = await this.modalCtrl.create({
      component: TextRecordComponent,
      backdropDismiss: false,  // Prevent closing when clicking outside
      cssClass: 'large-modal-1', //custom class for styling
      componentProps:{
        'initiator':'text_list_page',
        "text_info": item

      }
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
        this.updateRowValue(item,data)
        console.log("Data is:",data);

    }else{
    }  
  }

  async openTextRecorHistoryFormModal(item: any) {
    console.log("history of sound files for text is:",item.TextId);
    const modal = await this.modalCtrl.create({
      component: TextRecordHistoryComponent,
      backdropDismiss: false,  // Prevent closing when clicking outside
      cssClass: 'large-modal-3', //custom class for stylinsg
      componentProps:{
        'initiator':'text_list_page',
        "text_info": item,
        "currentTextIdForHistory":item.TextId,
        "showDataOf":'all_user'
        

      }
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
        console.log("dddData is:",data);
        console.log("numberOfAllsDataDelete:", data.numberOfAllsDataDelete);
        console.log("numberOfOwnDataDelete:", data.numberOfOwnDataDelete);
        this.updateAllRecordCountValue(item,data.numberOfAllsDataDelete,data.numberOfOwnDataDelete)

    }else{
    }  
  }

  async openOwnTextRecorHistoryFormModal(item: any) {
    console.log("history of sound files for text is:",item.TextId);
    const modal = await this.modalCtrl.create({
      component: TextRecordHistoryComponent,
      backdropDismiss: false,  // Prevent closing when clicking outside
      cssClass: 'large-modal-3', //custom class for stylinsg
      componentProps:{
        'initiator':'text_list_page',
        "text_info": item,
        "currentTextIdForHistory":item.TextId,
        "showDataOf":'current_user'
        

      }
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
        console.log("dddData is:",data);
        console.log("numberOfAllsDataDelete:", data.numberOfAllsDataDelete);
        console.log("numberOfOwnDataDelete:", data.numberOfOwnDataDelete);
        this.updateAllRecordCountValue(item,data.numberOfAllsDataDelete,data.numberOfOwnDataDelete)

    }else{
    }  
  }


  

  updateRowValue(item:any,data:any) {
    const index = this.textListData.findIndex(row => row.TextId === item.TextId);
    if (index !== -1) {
        this.textListData[index].AudioTextCount += data; // Increase count by 1 (unconditionally)
        this.textListData[index].TotalAudioTextCount += data; // Increase count by 1 (unconditionally)
    }
  }
  updateAllRecordCountValue(item:any,numberOfAllsDataDelete:any,numberOfOwnDataDelete:any) {
    const index = this.textListData.findIndex(row => row.TextId === item.TextId);
    if (index !== -1) {
        this.textListData[index].AudioTextCount -= numberOfOwnDataDelete; // Decrease count by 1 (unconditionally)
        this.textListData[index].TotalAudioTextCount -= numberOfAllsDataDelete; // Decrease count by 1 (unconditionally)
    }
  }


  goToMenu() {
    this.router.navigate(['/menu']);
  }

  openProfile(){
    console.log("Profile has been opened");
    // this.showProfileAlert();
  }

  // this.userName = localStorage.getItem('userName');
  //   this.userLanguage = localStorage.getItem('language');
  //   this.userAccent = localStorage.getItem('accent');
  //   this.userAge = localStorage.getItem('age');
  //   this.userGender = localStorage.getItem('gender');
  //   this.userId = localStorage.getItem('userId');


  // async showProfileAlert() {
  //   const alert = await this.alertController.create({
  //     header: 'User Profile',
  //     message: `
  //           Username: ${this.userName}
  //           Age: ${this.userAge}
  //           Gender: ${this.userGender}
  //           Accent: ${this.userAccent}
  //           Language: ${this.userLanguage}

  //       `,
  //     cssClass: 'custom-alert',
  //     buttons: [
  //       {
  //         text: 'Close',
  //         role: 'cancel'
  //       }
  //     ]
  //   });
  
  //   await alert.present();
  // }

 
  
  // async showProfileAlert() {
  //   const alert = await this.alertController.create({
  //     header: 'User Profile',
  //     message: `
  //       Username: ${this.userName}\n
  //       Age: ${this.userAge}\n
  //       Gender: ${this.userGender}\n
  //       Accent: ${this.userAccent}\n
  //       Language: ${this.userLanguage}
  //     `,
  //     cssClass: 'custom-alert',
  //     buttons: [
  //       {
  //         text: 'Close',
  //         role: 'cancel'
  //       }
  //     ]
  //   });
  
  //   await alert.present();
  //   const alertElement = document.querySelector('ion-alert.custom-alert'); // Or just 'ion-alert'
  //     if (alertElement) {
  //       const messageElement = alertElement.querySelector('.alert-message');
  //       if (messageElement) {
  //         messageElement.innerHTML = messageElement.innerHTML.replace(/\n/g, '<br>');
  //       }
  //     }

  // }

  onPageSizeChange(){
    this.currentPage = 1;
    console.log("Page size is:",this.pageSize);
    //make API call for retriveText()
    localStorage.setItem('currentPageSizeForHome',this.pageSize.toString());
    this.fetchTextList();
    
  }
  

  goToFirstPage(){
    console.log("go to first page");
    this.currentPage = 1;

    //make API call for retriveText()
    localStorage.setItem('currentPageForHome',this.currentPage.toString());
    this.fetchTextList();
    console.log("First Page is:",this.currentPage)
  }

  prevPage(): void{
    console.log("go to previous page");
    if (this.currentPage > 1) {
      this.currentPage--;

      //make API call for retriveText()
      localStorage.setItem('currentPageForHome',this.currentPage.toString());
      this.fetchTextList();
      console.log("Previous Page is:",this.currentPage)
    }
  }
  nextPage(): void{
    console.log("go to next page");
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      
      //make API call for retriveText()
      this.fetchTextList();
      localStorage.setItem('currentPageForHome',this.currentPage.toString());

      console.log("Next Page is:",this.currentPage)
    }
  }
  goToLastPage(): void{
    console.log("go to last page");
    this.currentPage = this.totalPages;

    //make API call for retriveText()
    this.fetchTextList();
    localStorage.setItem('currentPageForHome',this.currentPage.toString());

    console.log("Last Page is:",this.currentPage)
  }

  goToSpecificPage(pageNumber: number): void{
    console.log("Go to specific page number is:",pageNumber);

    console.log("go to specific page");
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.currentPage = pageNumber;
      // Any additional logic to handle page change

      //make API call for retriveText()
      this.fetchTextList();
      localStorage.setItem('currentPageForHome',this.currentPage.toString());

      console.log("Current Page is:",this.currentPage);
    }
  }


  async confirmLogout() {
    // if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedFilterValueForTTS');
          
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');

          localStorage.removeItem('notRemoveModelInferencingData');
          localStorage.removeItem('numberOfRecordedText');
          localStorage.removeItem('numberOfTotalRecordedText');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('langCategory');
  
          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };

}
